export const COLUMN_ID = 'settings';
export const COLUMN_WIDTH = 50;
